import { FunctionalComponent, h } from 'preact'
import style from './style.scss'

const Loading: FunctionalComponent = () => {
  return <div class={style["loading"]}>Loading...</div>
}

export default Loading
